import {ArenaFiltersConfigurationMap, IArenaViewModel} from "../arena-view-model.interface";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import React from "react";
import {OrbitSuspense} from "../../../../../components/base-components/orbit-suspense/orbit-suspense";
import {NewLiveCasinoArenaComponent} from "../../../../../components/arena-host/new-live-casino-arena/new-live-casino-arena.component";
import {GameInfo} from "../../../../games/game-info";
import {filtersConfigurationToMap} from "../../filters-configuration-to-map";
import {ArenaConfiguration} from "../../../../configurations/config-data-sections/arenas.configuration";
import {IGamesFilterStrategy} from "../../../../games-filter/strategies/games-filter-strategy.interface";
import {
    SimpleGamesFilterStrategy
} from "../../../../games-filter/strategies/simple-games-filter/simple-games-filter.strategy";

export class NewLiveCasinoArenaModel implements IArenaViewModel {
    constructor(public readonly arenaName: string,
                private readonly services: IServiceFactoryExtended) {
    }

    get listsCount(): number {
        return 0;
    }

    renderList(listPosition: number): React.ReactElement | null {
        return null;
    }

    getNextBatchSize(currentListPosition: number): number {
        return 0;
    }

    get configs(): ArenaConfiguration {
        return this.services.configuration.data.arenas[this.arenaName];
    }

    renderArena(): React.ReactElement | null {
        return (
            <OrbitSuspense>
                <NewLiveCasinoArenaComponent key={this.arenaName}
                                             arenaName={this.arenaName}
                                             configs={this.configs}/>
            </OrbitSuspense>
        );
    }

    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        return gamesInfo.filter(g => g.isLiveCasino);
    }

    get allArenaGamesForFiltering(): GameInfo[] {
        return [];
    }


    get filtersConfigurationMap(): ArenaFiltersConfigurationMap {
        return filtersConfigurationToMap(this.configs.filters);
    }

    getGamesFilteringStrategy(): IGamesFilterStrategy {
        return new SimpleGamesFilterStrategy(this.services);
    }

}